module.exports = __webpack_public_path__ + "static/media/daily-mirror.1867d6a1.png";